const HEADER_KEY = "X-CSRF-Token";

const getCsrfToken = () => {
	if (getCsrfToken.cachedToken) {
		return [getCsrfToken.cachedToken, HEADER_KEY];
	}

	const csrfToken = document.querySelector("[name=csrf-token]").content;
	getCsrfToken.cachedToken = csrfToken;

	return [csrfToken, HEADER_KEY];
};

getCsrfToken.cachedToken = null;

export default getCsrfToken;
